import axios from 'axios';
import { notification, message } from 'antd';
import CONFIG from '../../config';
import { url as urlImageStatic } from '../../helper/image';
//import Auth from './Auth';

const CSV_EVENT_URL = '/user/export-event/';

export const API_URL = CONFIG.API.url + "/" + CONFIG.API.suffix.api;

export const IMAGES_URL = (url = '') => {
    const suffix = CONFIG.API.suffix.image ?  CONFIG.API.suffix.image + "/" : ""

    if(url && url.includes('https://'))
        return url;
    else if(url && typeof url === "object" && url.length > 0 && url[0].url )
        return CONFIG.API.url + "/" + suffix + url[0].url;
    else if (url && typeof url === "string" && url.length > 0)
        return CONFIG.API.url + "/" + suffix + url;
    else
        return urlImageStatic("placeholder.png");
}

export const CSV_URL = (url = '') => {
    const suffix = CONFIG.API.suffix.csv ?  CONFIG.API.suffix.csv + "/" : ""

    return CONFIG.API.url + "/" + suffix + url;
}

const METHOD_NAME = "Bearer";
export const TOKEN_NAME_LOCALSTORAGE = METHOD_NAME + "_token";

const isJSON = (something) => {
    if (typeof something != 'string')
        something = JSON.stringify(something);

    try {
        JSON.parse(something);
        return true;
    } catch (e) {
        return false;
    }
}

export class API {
    static myInstance = null;

    constructor(){
        //Instance of axios 
        //Allow us to buil a pre-request
        this._axios = this.createInstance();
        //Issue on axios
        //If no data provided the POST is set as a GET
        this.defaultParams = {};
        //UI
        //message
        this._msg = {};

        this.messages = [];
    }

    /**
     * @returns {API}
     */
    static getInstance() {
        if (API.myInstance == null) {
            API.myInstance = new API();
        }

        return this.myInstance;
    }

    createInstance(token = this.getToken()){
        this.token = token;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': METHOD_NAME + ' ' + this.token,
        }

        if(CONFIG.DEV)
            headers.crossDomain = true;

        const _axios = axios.create({
            baseURL: API_URL,
            headers
        });

        // Add a request interceptor
        _axios.interceptors.request.use((config) => {
            const _message = {
                url: (config.baseURL.slice(-1) === '/' ? config.baseURL.substr(0, config.baseURL.length-1) : config.baseURL) + '/' + (config.url.charAt(0) === '/' ? config.url.substr(1) : config.url),
                ui : this._msg,
                loading: null
            }

            // iShow loading message before request is sent
            if(this._msg.loading)
                _message.loading = message.loading(this._msg.loading, 20000);

                this.messages.push(_message)
            this._msg = {};

            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });

        // Add a response interceptor
        _axios.interceptors.response.use((response) => {
            const _message = this.getMessage(response.config.url);
            //stop loading message
            if(typeof _message.loading === "function")
                _message.loading();

            //show success message
            if([200, 201, 202, 203, 204].includes(response.status) && _message.ui.success)
                message.success(_message.ui.success, CONFIG.UI.MESSAGE.TIME);

            return response;
        }, (error, test) => {
            const _message = this.getMessage(error.config.url);
            //stop loading message
            if(typeof _message.loading === "function")
                _message.loading();

            if(error.response){
                const { status, data } = error.response;

                //show error message
                if(_message.ui.error)
                    message.error(_message.ui.error, CONFIG.UI.MESSAGE.TIME);

                //if 401 === bad token
                else if(status === 401)
                    message.warning('Accès non autorisé')

                else if (status === 413)
                    message.warning('Fichiers transférés trop volumineux')
                
                else if ([500, 501, 502, 503].includes(status))
                    message.warning('Erreur seveur')

                //if 404 === not found
                else if(status === 404)
                    if(!data || !Array.isArray(data))
                        message.warning('404 - Données manquantes')
                    else
                        message.warning('404 - ' + data.join(', ') || data )

                //if data
                if(data){
                    if(isJSON(data)){
                        let i = 1;
                        for(let item in data) {
                            if(isNaN(item))
                                notification.warning({
                                    message: "La valeur " + item.split(/(?=[A-Z])/).join(' ') + " est mal renseigné",
                                    description: data[item],
                                    duration: 4.5 * i++
                                })
                            else
                                notification.warning({
                                    message: data[item],
                                    duration: 4.5 * i++
                                })
                        }
                    }
                    else {
                        notification.error({
                            message: data,
                            duration: 4.5
                        })
                    }
                }
            } else {
                message.error("erreur API", CONFIG.UI.MESSAGE.TIME);
            }

            // Do something with response error
            return Promise.reject(error);
        });
 
        return _axios;
    }

    msg(msg){

        this._msg = msg;
    }

    getMessage(url){
        const message = this.messages.filter(m => m.url === url)[0]
        this.messages = this.messages.filter(m => m.url !== url)

        return message || { ui: {}, loading: null };
    }

    getToken(){
        return localStorage.getItem(TOKEN_NAME_LOCALSTORAGE) || null;
    }

    setToken(token){
        if(!token) token = '';
        
        localStorage.setItem(TOKEN_NAME_LOCALSTORAGE, token);
        this._axios = this.createInstance(token);
    }

    get(url, params = this.defaultParams){
        this.check();

        return this._axios.get(url, { params });
    }

    post(url, params = this.defaultParams){
        this.check();

        return this._axios.post(url, params);
    }

    file(url, params = this.defaultParams, onUploadProgress = function(){ /* empty because ... */  }){
        this.check();

        return this._axios.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "mimeType": "multipart/form-data",
            },
            function(e) {
                if (e.total > 0) {
                  e.percent = e.loaded / e.total * 100;
                }
                onUploadProgress(e);
            }
          });
    }
    duplicateImages(url, id, imageURL) {
        const formData = new FormData();
        formData.append('eventId', id);
        formData.append('imageUrl', imageURL);
      
 
        return this._axios.post(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
      
      }
    
    getUsers(eventId) {
        return this._axios.get(`/event/${eventId}/getUsers`)
            .then(response => {

            // Récupérer la liste des utilisateurs depuis la réponse JSON
            const userList = response.data;
        
            // Utiliser la liste des utilisateurs comme vous le souhaitez (par exemple, l'afficher dans la console)
            console.log(userList);
        
            // Retourner la liste des utilisateurs pour une utilisation ultérieure si nécessaire

            return userList
            /* return API.post('/user/export/' + userList.map(u => u.id).join(','))
                .then((res) => window.open(CSV_URL(res.data))); */
        });
    }
    put(url, params = this.defaultParams){
        this.check();

        return this._axios.put(url, params); 
    }

    patch(url, params = this.defaultParams){
        this.check();

        return this._axios.patch(url, params); 
    }

    delete(url, params = this.defaultParams){
        this.check();

        return this._axios.delete(url, params);
    }

    check(){
        if(!this.token)
            this._axios = this.createInstance();
    }

    /**
     * Return a Promise where the csv Path shall be returned by the API
     * @param {Event Id as Valid Integer Value} eventId
     */
    getUserInEventAsCsvFile(eventId) {
        return this.get(CSV_EVENT_URL + eventId);
    }
}

export default new API();


// WEBPACK FOOTER //
// ./src/helper/api/Api.js